import store from '@/store'
import { AUTH_DISPATCH_GUEST_LOGIN, AUTH_EXPIRED_TOKEN, SET_QUERY } from '@/store/types'
import axios from 'axios'

axios.interceptors.response.use(resp => resp, async err => {
  const errorStatus = err.response?.status === 401
  const respMessage = err.response?.data?.message !== 'access_denied'
  
  if (errorStatus && respMessage) {
    const isGuestLogin = store.getters.isGuestLogin

    if (isGuestLogin) {
      await store.dispatch(AUTH_DISPATCH_GUEST_LOGIN)
      // Retry the original request with the new token
      const originalRequest = err.config
      if (originalRequest && !originalRequest._retry) {
        originalRequest._retry = true
        originalRequest.headers['x-ticket-token'] = store.getters.getToken
        return axios.request(originalRequest)
      }
    } else {
      store.commit(AUTH_EXPIRED_TOKEN, true)
      store.commit(SET_QUERY, {})
    }
  }

  return Promise.reject(err)
})